import ServiceBase from './ServiceBase';

export default class HeroBannerService extends ServiceBase {

    getHeroBanners() {
        return this.request('get', 'heroBanners/getHeroBanners');
    }
}
